export default __webpack_public_path__ + "static/media/33.182759b4.jpg";